// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip--hw7QW","menubarButton":"menubarButton--FPkCm","menubarButtonActive":"menubarButtonActive--EDlkg"};